// extracted by mini-css-extract-plugin
export const mascot = "header-module--mascot--R1R4C";
export const link = "header-module--link--3R2_R";
export const root = "header-module--root--2Pllp";
export const wrapper = "header-module--wrapper--182n5";
export const branding = "header-module--branding--1PjA2";
export const toggleNavButton = "header-module--toggleNavButton--34Tf4";
export const nav = "header-module--nav--106zH";
export const showNav = "header-module--showNav--CuuOZ";